import { render, staticRenderFns } from "./Endpage.vue?vue&type=template&id=33dc511f&scoped=true"
import script from "./Endpage.vue?vue&type=script&lang=js"
export * from "./Endpage.vue?vue&type=script&lang=js"
import style0 from "./Endpage.vue?vue&type=style&index=0&id=33dc511f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc511f",
  null
  
)

export default component.exports